import styled from 'styled-components'
import { css, colors } from 'styles'

const StyledMembershipSelect = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  color: ${colors.main};
  padding: 2rem 0;
  ${p =>
    p.vipEnabled &&
    css`
      flex-flow: column nowrap;
      padding: 0;
    `}

  &.no-vip {
    margin-top: 4rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export default StyledMembershipSelect
